import houses from "../../../../assets2/images/houses.svg";
import bed from "../../../../assets2/images/bed.svg";
export default function HotelIcons({ room = 0, venu = 0 }) {
	return (
		<div className="flex items-center w-full justify-start gap-4">
			<div className="flex items-center gap-2">
				<img src={bed} alt="" />
				{/* <p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em]">
					{room > 1 ? `${room} Rooms` : `${room} Room`}
				</p> */}
				<p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em] whitespace-nowrap overflow-hidden text-ellipsis">
					{room > 1 ? `${room} Rooms` : `${room} Room`}
				</p>
			</div>
			<>
				<h1 className="text-secondary text-xl">•</h1>
				<div className="flex items-center gap-2">
					<img src={houses} alt="" />
					{/* <p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em]">
						{venu > 1 ? `${venu} venues` : `${venu} venue`}
					</p> */}
					<p className="text-secondary font-outfit font-normal text-[14px] leading-[156%] tracking-[0.01em] whitespace-nowrap overflow-hidden text-ellipsis">
						{venu > 1 ? `${venu} venues` : `${venu} venue`}
					</p>
				</div>
			</>
		</div>
	);
}
